import Icon from "@mui/material/Icon";
import loadable from "@loadable/component";
import network from "contracts/Invest.json";

const Home = loadable(() => import("pages/Home"));
const Investment = loadable(() => import("pages/Investments"));
const OrderList = loadable(() => import("pages/order-list"));
const UserDashboard = loadable(() => import("pages/Dashboard"));

const routes = [
  {
    type: "collapse",
    name: "Home",
    key: "",
    route: "/",
    component: <Home />,
    icon: <Icon fontSize="medium">home</Icon>,
    noCollapse: true,
  },
  { type: "divider", key: "divider-1" },
  { type: "title", title: "Investment", key: "title-docs" },
  {
    type: "collapse",
    name: "Deposit",
    key: "investment",
    route: "/investment",
    component: <Investment />,
    icon: <Icon fontSize="medium">attach_money</Icon>,
    noCollapse: true,
  },
  {
    name: "Order List",
    key: "trade-history",
    route: "/trade-history",
    component: <OrderList />,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    component: <UserDashboard />,
    icon: <Icon fontSize="medium">account_balance_wallet</Icon>,
    noCollapse: true,
  },
  { type: "divider", key: "divider-2" },
  { type: "title", title: "Docs", key: "title-docs1" },
  {
    type: "collapse",
    name: "Smart Contract",
    key: "changelog",
    href: `https://bscscan.com/address/${network.networks[56].address}`,
    icon: <Icon fontSize="medium">receipt_long</Icon>,
    noCollapse: true,
  },
];

export default routes;
